module.exports = __webpack_public_path__ + "img/router_shopee.2114c77d.jpg";